<!-- 收藏卡片 -->
<template>
  <div>
    <router-link
      :to="{ path: '/pos-detail', query: { id: item.recruit_id } }"
      class="mb-[20px] flex justify-between rounded bg-white px-[24px] py-[20px] transition-shadow hover:shadow-md"
      v-for="item in collectData"
      :key="item.id"
    >
      <div>
        <div class="mb-[5px] flex items-center">
          <span class="mr-[10px] text-[18px] text-[#000]">{{ item.recruit_title }}</span>
        </div>
        <p class="mb-[5px] flex items-center text-[14px] text-[#9c9c9c]">
          <span>收藏时间：{{ item.create_time }}</span>
        </p>
      </div>
      <div>
        <el-popconfirm title="取消收藏该岗位？" @confirm="handleCancelCollect(item.id)">
          <el-button slot="reference" @click.prevent>取消收藏</el-button>
        </el-popconfirm>
      </div>
    </router-link>
  </div>
</template>

<script>
import { EventBus } from '@/utils/eventbus';
import { formatDate } from '@/utils/tool';
import { collectList, collectDelete } from '@/api/position';

export default {
  name: 'AccountCollection',
  data() {
    return {
      collectData: [
        {
          id: '',
          recruit_id: '',
          status: '',
          create_time: '',
        },
      ],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      // 获取收藏列表
      collectList().then((res) => {
        const data = res.data.rows;
        data.map((item) => {
          item.create_time = formatDate(item.create_time, 'YYYY-MM-DD');
          return item;
        });
        this.collectData = res.data.rows;
        EventBus.$emit('update-count');
      });
    },
    // 取消收藏
    handleCancelCollect(ids) {
      collectDelete({ ids })
        .then((res) => {
          this.$message.success('取消收藏成功');
        })
        .catch((err) => {
          this.$message.error('取消收藏失败');
        })
        .finally(() => {
          this.getData();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.tag-container .el-tag + .el-tag {
  margin-left: 10px;
}
</style>
